<template>
    <div class="main main--hasHeader main--hasFooter">
        <div class="reserve04">
            <reserve-header :reserve_type="'drive'" :reserve_target="'reserve'"></reserve-header>
<!-- /{{ drive_node }}/ -->
            <div v-if="reserve_step == 10">
                <div class="fullContainer">
                    <div class="calendarPager">
                        <div class="customContainer">
                            <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                <li class="calendarPager__button ">
                                    <a class="calendarPager__link calendarPager__link--prev " @click="prev(1)">
                                        <i class="bi bi-chevron-left"></i>
                                    </a>
                                </li>
                                <li class="calendarPager__date">{{ sprm.date }}</li>
                                <li class="calendarPager__button "></li>
                            </ul>
                        </div>
                    </div>
                    <div class="py-4">
                        <!-- <p class="pb-1 mb-1 text-primary">
                        ドライビングコース内における事故に関しては、通常の自動車保険では免責となります。<br>
                        （ドライビングコース内の事故の補償を希望される場合はこちら）
                        </p> -->
                        {{ word_chg('予約内容を入力してください。') }}<br>
                        <span class="text-danger">※</span>{{ word_chg('は必須項目です。') }}
                    </div>
                </div>
                <!-- {{ ledger_type }} -->
                <div class="customContainer">
                    <ul class="reserve05__reserves">
                        <li class="reserve05__reserve" v-for="(node, node_index) in reserve_node" :key="node">
                            <!-- {{ node.kbns_price_list }} -->
                            <h3 class="reserve05__title mb-2">{{ word_chg(node.label) }} <span v-if="node.label != category_label(node.category_id)">({{ word_chg(category_label(node.category_id)) }})</span></h3>
                            <p v-if="node.information_message" class="my-2 text-center">
                                [{{ word_chg(node.information_message) }}]
                            </p>
                            <p class="reserve05__time" v-for="item in node.items" :key="item">
                                {{item.time_diff}} min  {{ item.start_date_time }} - {{ item.end_date_time }}
                            </p>
                            <div class="reserveRunSearch__row d-flex border-bottom">
                                <div class="reserveRunSearch__name">
                                    <label for="ReserveNum">{{word_chg('料金')}}</label>
                                </div>
                                <div class="reserveRunSearch__item">
                                    <div class="row mb-3" v-if="typeof node === 'object' && typeof node.kbns_price_list === 'object' && Object.keys(node.kbns_price_list).length > 0">
                                        <div class="col" v-for="kbn_price in node.kbns_price_list" :key="kbn_price">
                                            <span style="font-size: 1.34rem;">{{ word_chg(kbn_price.kbn_label) }}</span><br>
                                            ¥{{  kbn_price.label }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="reserveRunSearch__row d-flex">
                                <div class="reserveRunSearch__name">
                                    <label :for="'ReserveNum_' + node_index">{{word_chg('走行人数')}}</label>
                                </div>
                                <div class="reserveRunSearch__item">
                                    <p>
                                        <select 
                                            :name="'ReserveNum_' + node_index"
                                            v-model="node.reserve_num"
                                            :id="'ReserveNum_' + node_index"
                                            @change="change_reserve_num(node.id)"
                                            class="form-control form-select reserveRunSearch__select">
                                            <option v-for="list in reserve_num_list_node(node.id)" :key="list" :value="list.key">
                                                {{ list.label }}
                                            </option>
                                        </select>
                                    </p>
                                </div>
                            </div>

                            <ul class="reserve05__members border-top border-dark py-3" v-for="(member, index) in node.members" :key="member">
                                <!-- {{ member.ledger }} -->
                                <li class="reserve05__member d-flex align-items-center mb-1" >
                                    <div class="reserve05__label">DRIVER[{{ (index + 1) }}]</div>
                                    <div class="reserve05__memberType">
                                        <div class="mb-1 row">
                                            <div class="col-12">
                                                <span class="text-danger">※</span>{{ word_chg('走行者') }}
                                            </div>
                                        </div>
                                        <div class="mb-1 row">
                                            <div class="col-10">
                                            <bs-select
                                                :options="driverTypeList(node)"
                                                v-model="member.target"
                                                :name="'target_' + node_index + '_' + index"
                                                class="reserve05__select"
                                                @parentFunc="changeDriverType(index, node_index)"
                                            ></bs-select>
                                            </div>
                                            <div class="col-2 text-end">
                                                <a @click="delMemberNum(node.id, index)" class="btn btn-warning" v-if="index >0"><i class="bi bi-trash"></i></a>
                                            </div>
                                        </div>
                                        <div class="mb-1">
                                            <!-- 友達 -->
                                            <bs-select
                                                v-if="member.target==100"
                                                :name="'friend_sel_' + node_index + '_' + index"
                                                :options="getFriendDataAddList"
                                                v-model="member.use_m_id"
                                                :null-option="false"
                                                class="reserve05__select"
                                            ></bs-select>
                                            <!-- ゲスト -->
                                            <bs-select
                                                v-else-if="member.target==200 && Object.keys(getGuestDataAddList).length > 0"
                                                :name="'guest_sel_' + node_index + '_' + index"
                                                :options="getGuestDataAddList"
                                                v-model="member.use_guest_id"
                                                :null-option="true"
                                                class="reserve05__select"
                                            ></bs-select>
                                            <div v-else-if="member.target==200">
                                                <p class="py-2 ">※ゲスト情報が登録されていません</p>
                                                <div class="py-2">
                                                    <router-link to="/user/guest">ゲスト登録はこちら</router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- お友達追加 -->
                                        <div class=""
                                            v-if="member.target==100 && member.use_m_id == 0">
                                            <div class="members-inquiry__data mb-2">
                                                <label class="form-label">{{ word_chg('お友達検索') }}</label>
                                                <input type="text" v-model="member.tmp_search_words" class="mb-1" placeholder="name">
                                            </div>
                                            <div class="text-end">
                                                <button class="btn btn-light btn-lg" @click="friendSearch(member)"><i class="bi bi-search"></i></button>
                                            </div>
                                            <div class=" mb-2">
                                                <div v-for="mem in member.tmp_search_list" :key="mem">
                                                    <p class="text-center">
                                                        <a class="reserve05__addMemberLink" @click="addFriend(member, mem)">＋ {{ mem.true_name_label }}</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- ゲスト追加 -->
                                        <div class=""
                                            v-if="member.target==200 && member.use_guest_id == 0">
                                            <!-- <div class="members-inquiry__data mb-2">
                                                <label class="form-label">ゲストのお名前</label>
                                                <input :type="ledger.input_type" v-model="member.tmp_label" class="">
                                            </div>
                                            <div class="members-inquiry__data mb-2">
                                                <label class="form-label">ゲストのお電話番号</label>
                                                <input :type="ledger.input_type" v-model="member.tmp_label" class="">
                                            </div> -->
                                        </div>
                                        <div class="members-inquiry__data mb-2" v-for="(ledger, l_idx) in ledger_type_list(node.category_id)" :key="l_idx">
                                            <!-- {{ member.target }}: {{ ledger.is_user_view }} -->
                                            <label
                                                :for="'Ledger_' + index + '_' + l_idx"
                                                class="form-label"
                                                v-if="(ledger.is_user_view == 1 && ledger.relation_column != 'car_id') || ((member.target ==1 || member.target==200) && ledger.is_user_view == 1)" 
                                            >
                                                <span class="text-danger" v-if="ledger.is_user_require==1">※</span>{{ word_chg(ledger.label) }}
                                            </label>
                                            <div v-if="ledger.user_description">
                                                <p style="font-size: 1.5rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                            </div>
                                            <div v-if="ledger.is_user_view == 1 && ledger.relation_column == 'car_id' && (member.target==1 || member.target==200)">
                                                <bs-select
                                                    :name="'Ledger_' + index + '_' + l_idx"
                                                    :options="getCarData"
                                                    v-model="member.ledger[l_idx].value"
                                                    :null-option="true"
                                                    :id="'Ledger_' + index + '_' + l_idx"
                                                    class="reserve05__select"
                                                    @parentFunc="selectCarId(member.ledger[l_idx].value, node_index, index)"
                                                    ></bs-select>
                                            </div>
                                            <div v-if="ledger.is_user_view == 1 && ['select'].includes(ledger.input_type) && ledger.default_param && typeof ledger.default_param === 'object'" class="mb-2">
                                                <bs-select
                                                    :name="'Ledger_' + index + '_' + l_idx"
                                                    :options="car_type_param(ledger.default_param)"
                                                    v-model="member.ledger[l_idx].value"
                                                    :null-option="true"
                                                    :id="'Ledger_' + index + '_' + l_idx"
                                                    class="reserve05__select"
                                                    >
                                                </bs-select>
                                            </div>
                                            <div v-else-if="ledger.is_user_view == 1 && ledger.relation_column == 'car_id' && member.target!=1">

                                            </div>
                                            <div v-else-if="ledger.is_user_view == 1 && ['text', 'number', 'date'].includes(ledger.input_type)">
                                                <input :type="ledger.input_type" v-model="member.ledger[l_idx].value" class="" :placeholder="word_chg(ledger.label)">
                                            </div>
                                            <div v-else-if="ledger.is_user_view == 1 && ['textarea'].includes(ledger.input_type)">
                                                <textarea v-model="member.ledger[l_idx].value" class="" :placeholder="word_chg(ledger.label)"></textarea>
                                            </div>
                                            <div v-else-if="ledger.is_user_view == 0">
                                                <input type="hidden" v-model="member.ledger[l_idx].value">
                                            </div>
                                        </div>
                                        <div class="">
                                            <label class="form-label">{{ word_chg('料金') }}</label>
                                            <!-- <div>{{ getDriverPrice_2(index, node_index) }} <span v-if="member.price> 0">円</span></div> -->
                                            <div><span v-if="member.price> 0">¥</span> {{ getDriverPrice(node.id, member) }}</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <p class="reserve05__addMember py-3">
                                <a class="reserve05__addMemberLink" @click="addMemberNum(node.id)">＋ {{ word_chg('メンバーを追加登録する') }}</a>
                            </p>
                            <p class="reserve05__addMember border-top border-dark py-3">
                                {{ word_chg('走行枠合計金額') }}:<span v-if="parseInt(getDriverPriceNodeTotal(node.id))> 0">¥</span> {{ number_format(getDriverPriceNodeTotal(node.id)) }}
                            </p>
                        </li>
                    </ul>
                    <p class="reserve05__submit text-end py-3">
                        {{ word_chg('合計金額') }}:<span v-if="parseInt(getDriverPriceTotal)> 0">¥</span> {{ number_format(getDriverPriceTotal) }}
                    </p>
                    <p class="reserve05__submit">
                        <button class="button02" @click="confirm">{{ word_chg('予約内容を確認する') }}</button>
                    </p>
                </div>
            </div>
            <div v-else-if="reserve_step == 100">
                <div class="fullContainer">
                    <div class="calendarPager">
                        <div class="customContainer">
                            <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                <li class="calendarPager__button ">
                                    <a class="calendarPager__link calendarPager__link--prev " @click="prev(10)">
                                        <i class="bi bi-chevron-left"></i>
                                    </a>
                                </li>
                                <li class="calendarPager__date">{{ sprm.date }}</li>
                                <li class="calendarPager__button "></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="customContainer">
                    <ul class="reserve05__reserves">
                        <li class="reserve05__reserve" v-for="node in reserve_node" :key="node">
                            <!-- {{ node.kbns_price_list }} -->
                            <h3 class="reserve05__title">{{ word_chg(node.label) }} <span v-if="node.label != category_label(node.category_id)">({{ word_chg(category_label(node.category_id)) }})</span></h3>
                            <p class="reserve05__time" v-for="item in node.items" :key="item">
                                {{item.time_diff}} min  {{ item.start_date_time }} - {{ item.end_date_time }}
                            </p>
                            <div class="reserveRunSearch__row d-flex">
                                <div class="reserveRunSearch__name_c">
                                    <label for="ReserveNum">{{word_chg('走行人数')}}</label>
                                </div>
                                <div class="reserveRunSearch__item_c">
                                    <p>
                                        {{ node.reserve_num }} {{ word_chg('select人') }}
                                    </p>
                                </div>
                            </div>
                            <ul class="reserve05__members border-top border-dark py-3" v-for="(member, index) in node.members" :key="member">
                                <li class="reserve05__member d-flex align-items-center mb-1" >
                                    <div class="reserve05__label">DRIVER[{{ (index + 1) }}]</div>
                                    <div class="reserve05__memberType">
                                        <div class="mb-1 row">
                                            <div class="col-4">{{ word_chg('走行者') }}</div>
                                            <div class="col-8">
                                                <!-- 友達 -->
                                                <p v-if="member.target==100">
                                                    {{ list_val_set(member.use_m_id, getFriendDataAddList) }}
                                                    ({{ list_val_set(member.target, driverTypeList(node)) }})
                                                </p>
                                                <!-- ゲスト -->
                                                <p v-else-if="member.target==200">
                                                    {{ list_val_set(member.use_guest_id, getGuestDataAddList) }}
                                                    ({{ list_val_set(member.target, driverTypeList(node)) }})
                                                </p>
                                                <p v-else>
                                                    {{ list_val_set(member.target, driverTypeList(node)) }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="members-inquiry__data mb-2 row" v-for="(ledger, l_idx) in ledger_type_list(node.category_id)" :key="l_idx">
                                            <div class="col-4">
                                                <label
                                                    :for="'Ledger_' + index + '_' + l_idx"
                                                    class="form-label"
                                                    v-if="(ledger.is_user_view == 1 && ledger.relation_column != 'car_id') || (member.target ==1 && ledger.is_user_view == 1)" 
                                                >
                                                    {{ word_chg(ledger.label) }}
                                                </label>
                                            </div>
                                            <div class="col-8">
                                                <div v-if="ledger.is_user_view == 1 && ledger.relation_column == 'car_id' && member.target==1">
                                                    <!-- {{ list_val_set(member.ledger[l_idx].value, getCarData) }} -->
                                                    {{ list_val_set(get_ledger_value_by_param(member, ledger.id), getCarData) }}
                                                </div>
                                                <div v-if="ledger.is_user_view == 1 && ['select'].includes(ledger.input_type) && ledger.default_param && typeof ledger.default_param === 'object'" class="mb-2">
                                                    <!-- {{ list_val_set(member.ledger[l_idx].value, ledger.default_param) }}?{{ member.ledger[l_idx].value }} -->
                                                    {{ list_val_set(get_ledger_value_by_param(member, ledger.id), ledger.default_param) }}
                                                </div>
                                                <div v-else-if="ledger.is_user_view == 1 && ledger.relation_column == 'car_id' && member.target!=1">

                                                </div>
                                                <div v-else-if="ledger.is_user_view == 1 && ['text', 'number', 'date', 'textarea'].includes(ledger.input_type)">
                                                    <!-- {{ word_chg(member.ledger[l_idx].value) }} -->
                                                    {{ get_ledger_value_by_param(member, ledger.id) }}
                                                </div>
                                                <!-- <div v-else-if="ledger.is_user_view == 0">
                                                    <input type="hidden" v-model="member.ledger[l_idx].value">
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-4">
                                                <label class="form-label">{{ word_chg('料金') }}</label>
                                            </div>
                                            <div class="col-8">
                                                <!-- {{ getDriverPrice_2(index, node_index) }} <span v-if="member.price> 0">円</span> -->
                                                <span v-if="member.price> 0">¥</span>{{ number_format(getDriverPrice(node.id, member)) }} 
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <p class="reserve05__submit">
                        <button class="button02" @click="reservation">{{ word_chg('予約する') }}</button>
                    </p>
                </div>
            </div>
            <div v-else-if="reserve_step == 1">
                <div class="customContainer">
                    <div class="reserveRunSearch">
                        <div class="reserveRunSearch__row d-flex">
                            <div class="reserveRunSearch__name">
                                <label>{{word_chg('日付')}}</label>
                            </div>
                            <div class="reserveRunSearch__item reserveRunSearch__item--date">
                                <p class="reserveRunSearch__dateP01">
                                    <input class="reserveRunSearch__date" type="date" v-model="sprm.date" @change="searchNode()"/>
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex" v-if="false"><!--非表示-->
                            <div class="reserveRunSearch__name">
                                <label for="ReserveNum">{{word_chg('走行人数')}}</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :name="'ReserveNum'"
                                        :options="reserve_num_list"
                                        v-model="sprm.reserve_num"
                                        :null-option="false"
                                        id="ReserveNum"
                                        class="reserveRunSearch__select"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex" v-if="sprmFrmDetailSw">
                            <div class="reserveRunSearch__name">
                                <label for="CategoryId">{{ word_chg('プログラム') }}</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :name="'drive_node_category'"
                                        :options="drive_node_category"
                                        v-model="sprm.category_id"
                                        :null-option="true"
                                        id="CategoryId"
                                        class="reserveRunSearch__select"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex" v-if="false">
                            <div class="reserveRunSearch__name reserveRunSearch__name--top">
                                <label>{{ word_chg('ゲスト走行') }}</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <ul class="row">
                                    <li class="col-4">
                                        <label class="reserveRunSearch__checkLabel">
                                            <input class="reserveRunSearch__check" type="checkbox" v-model="sprm.is_guest"/>{{ word_chg('可能') }}
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p class="reserveRunSearch__search d-none">
                            <button class="button02 button02--gray reserveRunSearch__searchButton" @click="searchNode">{{ word_chg('検索') }}</button>
                        </p>
                    </div>
                </div>
                <div class="fullContainer">
                    <hr class="reserve04__border">
                </div>
                <div class="customContainer">
                    <p class="reserve04__text">{{ word_chg('ご希望の走行枠を選択してください。') }}</p>
                </div>

                <div class="fullContainer" v-if="rsvNodeListSw">
                    <p class="reserve04__button" v-if="Object.keys(selected_node_ids).length > 0">
                        <!-- <button class="button02 reserve04__button" @click="next" :disabled="Object.keys(selected_node_ids).length <= 0">予約を進める</button> -->
                    </p>
                    <div class="reserveTimeSchedule reserve04__schedule">
                        <div class="calendarPager">
                            <div class="customContainer">
                                <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                    <li class="calendarPager__button "><a class="calendarPager__link calendarPager__link--prev d-none" href="">Prev</a></li>
                                    <li class="calendarPager__date">{{ sprm.date }}</li>
                                    <li class="calendarPager__button "><a class="calendarPager__link calendarPager__link--next d-none" href="">Next</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="customContainer">
                            <ul class="reserveTimeSchedule__wrapper">
                                <li class="reserveTimeSchedule__li" v-for="(time, t_i) in timesc_unit" :key="time" :style="li_timesc_style">
                                    <p class="reserveTimeSchedule__time" :style="(t_i%2==0)? 'visibility:visible;': 'visibility: hidden;'">{{ time.label }}</p>
                                    <div v-for="item in get_drive_node_item(time.label, [0])" :key="item">
                                        <p v-if="item.available_view=='false'" class="d-none"></p>
                                        <p v-else-if="item.col_num == 0" @click="tapNodeP(item.node_id, item.available_reservation)" :class="node_class(item) + ' '" :style="node_style(item)">
                                            <span class="reserveTimeSchedule__name">
                                                {{ word_chg(item.label) }}<br v-if="item.time_diff > 20" />
                                                {{item.time_diff}}min<br>
                                                {{ item.start_date_time }} - {{item.end_date_time  }}
                                            </span><br v-if="item.time_diff > 20" />
                                            <span class="reserveTimeSchedule__name text-center" v-if="(item.available_reservation || (item.available_reservation_cd =='NOVACANCY' && item.available_reservation == false))">
                                                <!-- <span v-if="getNodePrice_to_member(item.node_id) != 0" class="d-block">¥{{ getNodePrice_to_member(item.node_id) }}</span> -->
                                                <span v-if="getNodeSubLabel(item)" class="d-block">{{ getNodeSubLabel(item) }}</span>
                                                <span v-if="parseInt(item.remain_count) > 6">
                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                </span>
                                                <span v-else-if="parseInt(item.remain_count) >= 0 && parseInt(item.reserve_limit) > 0">
                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                </span>
                                                <span v-else-if="parseInt(item.remain_count) <= 0">☓</span>
                                            </span>
                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='NOTRESERVE'"></span>
                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='OVERDUE'">{{ word_chg('受付期間外') }}</span>
                                            <span class="reserveTimeSchedule__status" v-else>☓</span>
                                        </p>
                                    </div>
                                    <div v-for="item in get_drive_node_item(time.label, [1, 2, 3])" :key="item">
                                        <div v-if="item.available_view==false" class="d-none">{{ item.available_view_cd }}</div>
                                        <div v-else class="row gx-10">
                                            <div class="col-4">
                                                <div class="reserveTimeSchedule__column" v-if="item.col_num == 1">
                                                    <label @click="tapNodeP(item.node_id, item.available_reservation)" :class="node_class(item) + ' '" :style="node_style(item)">
                                                        <p :class="node_p_style(item)">
                                                            <span class="reserveTimeSchedule__name">
                                                                {{ word_chg(item.label) }}<br v-if="item.time_diff > 20" />
                                                                {{item.time_diff}}min<br/>
                                                                <!-- <span v-if="getNodePrice_to_member(item.node_id) != 0" class="d-block">¥{{ getNodePrice_to_member(item.node_id) }}</span> -->
                                                                <span v-if="getNodeSubLabel(item)" class="d-block">{{ getNodeSubLabel(item) }}</span>
                                                                
                                                                {{ item.start_date_time }} - {{item.end_date_time  }}
                                                            </span>
                                                            <span class="reserveTimeSchedule__name text-center" v-if="(item.available_reservation || (item.available_reservation_cd =='NOVACANCY' && item.available_reservation == false))">
                                                                <span v-if="parseInt(item.remain_count) > 6">
                                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                                </span>
                                                                <span v-else-if="parseInt(item.remain_count) >= 0 && parseInt(item.reserve_limit) > 0">
                                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                                </span>
                                                                <span v-else-if="parseInt(item.remain_count) <= 0">☓</span>
                                                            </span>
                                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='NOTRESERVE'"></span>
                                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='OVERDUE'">{{ word_chg('受付期間外') }}</span>
                                                            <span class="reserveTimeSchedule__name" v-else>☓</span>
                                                            <!-- <span class="reserveTimeSchedule__status">{{ item.available_reservation }}</span> -->
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="reserveTimeSchedule__column" v-if="item.col_num == 2">
                                                    <label @click="tapNodeP(item.node_id, item.available_reservation)" :class="node_class(item) + ' '" :style="node_style(item)">
                                                        <p :class="node_p_style(item)">
                                                            <span class="reserveTimeSchedule__name">
                                                                {{ word_chg(item.label) }}<br v-if="item.time_diff > 20" />
                                                                {{item.time_diff}}min<br/>
                                                                <!-- <span v-if="getNodePrice_to_member(item.node_id) != 0" class="d-block">¥{{ getNodePrice_to_member(item.node_id) }}</span> -->
                                                                <span v-if="getNodeSubLabel(item)" class="d-block">{{ getNodeSubLabel(item) }}</span>
                                                                {{ item.start_date_time }} - {{item.end_date_time  }}
                                                            </span>
                                                            <span class="reserveTimeSchedule__name text-center" v-if="(item.available_reservation || (item.available_reservation_cd =='NOVACANCY' && item.available_reservation == false))">
                                                                <span v-if="parseInt(item.remain_count) > 6">
                                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                                </span>
                                                                <span v-else-if="parseInt(item.remain_count) >= 0 && parseInt(item.reserve_limit) > 0">
                                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                                </span>
                                                                <span v-else-if="parseInt(item.remain_count) <= 0">☓</span>
                                                            </span>
                                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='NOTRESERVE'"></span>
                                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='OVERDUE'">{{ word_chg('受付期間外') }}</span>
                                                            <span class="reserveTimeSchedule__name" v-else>☓</span>
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="reserveTimeSchedule__column" v-if="item.col_num == 3">
                                                    <label @click="tapNodeP(item.node_id, item.available_reservation)" :class="node_class(item) + ' '" :style="node_style(item)">
                                                        <p :class="node_p_style(item)">
                                                            <span class="reserveTimeSchedule__name">
                                                                {{ word_chg(item.label) }}<br v-if="item.time_diff > 20" />
                                                                {{item.time_diff}}min<br/>
                                                                <!-- <span v-if="getNodePrice_to_member(item.node_id) != 0" class="d-block">¥{{ getNodePrice_to_member(item.node_id) }}</span> -->
                                                                <span v-if="getNodeSubLabel(item)" class="d-block">{{ getNodeSubLabel(item) }}</span>
                                                                {{ item.start_date_time }} - {{item.end_date_time  }}
                                                            </span>
                                                            <span class="reserveTimeSchedule__name text-center" v-if="(item.available_reservation || (item.available_reservation_cd =='NOVACANCY' && item.available_reservation == false))">
                                                                <span v-if="parseInt(item.remain_count) > 6">
                                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                                </span>
                                                                <span v-else-if="parseInt(item.remain_count) >= 0 && parseInt(item.reserve_limit) > 0">
                                                                    {{ word_chg('残_') }}:{{ item.remain_count }}
                                                                </span>
                                                                <span v-else-if="parseInt(item.remain_count) <= 0">☓</span></span>
                                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='NOTRESERVE'"></span>
                                                            <span class="reserveTimeSchedule__name" v-else-if="item.available_reservation_cd =='OVERDUE'">{{ word_chg('受付期間外') }}</span>
                                                            <span class="reserveTimeSchedule__name" v-else>☓</span>
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <p class="reserve04__button_sticky reserve04__button" v-if="Object.keys(selected_node_ids).length > 0">
                        <button class="button02 reserve04__button" @click="next" :disabled="Object.keys(selected_node_ids).length <= 0">{{ word_chg('予約を進める') }}</button>
                    </p>
                    <p class="reserve04__button_sticky reserve04__button" v-else>
                        {{ word_chg('予約枠を選択してください。') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.reserve04__button_sticky {
    position: sticky;
    bottom: 10.8777194299rem;
    z-index: 1000;
   
}
.reserveRunSearch__name_c {
    width: 20.2025506377rem;
    padding-top: 1.5003750938rem;
}
.reserveRunSearch__item_c {
    width: calc(100% - 20.2025506377rem);
}
.reserveRunSearch__item_c p {
    padding-top: 1.5003750938rem;
}
.reserveTimeSchedule__label--10min {
    height: calc(5.62640660165 - 6px) !important;
}
.reserveTimeSchedule__label--20min {
    height: calc(11.2528132033rem - 6px) !important;
}
.reserveTimeSchedule__label--30min {
    height: calc(16.879219805rem - 6px) !important;
}
.reserveTimeSchedule__label--40min {
    height: calc(22.5056264066rem - 6px) !important;
}
.reserveTimeSchedule__label--50min {
    height: calc(28.1320330083rem - 6px) !important;
}
.reserveTimeSchedule__label--60min {
    height: calc(33.7584396099rem - 6px) !important;
}
.reserveTimeSchedule__label--70min {
    height: calc(39.3848462115rem - 6px) !important;
}
.reserveTimeSchedule__label--80min {
    height: calc(45.0112528131rem - 6px) !important;
}
.reserveTimeSchedule__label--90min {
    height: calc(50.6376594148rem - 6px) !important;
}
.reserveTimeSchedule__label--100min {
    height: calc(56.2640660165rem - 6px) !important;
}
.reserveTimeSchedule__label--110min {
    height: calc(61.8904726181rem - 6px) !important;
}
.reserveTimeSchedule__label--120min {
    height: calc(67.5168792197rem - 6px) !important;
}
.reserveTimeSchedule__label--130min {
    height: calc(73.1432858214rem - 6px) !important;
}
.reserveTimeSchedule__label--140min {
    height: calc(78.7696924231rem - 6px) !important;
}
.reserveTimeSchedule__label--150min {
    height: calc(84.3960990248rem - 6px) !important;
}
.reserveTimeSchedule__label--160min {
    height: calc(90.0225056264rem - 6px) !important;
}
.reserveTimeSchedule__label--170min {
    height: calc(95.6489122281rem - 6px) !important;
}
.reserveTimeSchedule__label--180min {
    height: calc(101.27531883rem - 6px) !important;
}
</style>
<script>
// import driveReservationList from '../Drive/ListReservationView.vue'
import reserveHeader from '../../organisms/BsReserveHeader.vue';
import BsSelect from '../../atoms/BsSelect.vue'
// import BsRadio from '../../atoms/BsRadio.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import config from '../../../const'
import axios from 'axios'
import Common from '../../../common/common'

export default {
    name: 'BsReservationDriveView',
    data: function () {
        return {
            sprm: {
                date: moment().format("YYYY-MM-DD"),
                day: moment().format("D"),
                reserve_num: 1,
                category_id: '',
                is_guest: false
            },
            sprmFrmDetailSw: false,
            selected_node_ids: [],

            reserve_step: 1,

            reserve_node: [],

            add_friend_list: [],

            form_res: false,

            reserve: [
                '99','99','99'
            ],
            search_name: '',
            driver_cnt: [
                0,
                0,
                0
            ],
            guest_input_form_sw: false,
        }
    },
    props: {
        // param_reserve_num: {
        //     type: Number,
        //     // default: 1
        // },
        // param_category_id: {
        //     type: Number,
        //     // default: 1
        // },
        displayClass: {
            type: String,
            default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        },
    },
    components: {
        // driveReservationList,
        reserveHeader,
        BsSelect,
        // BsRadio,
    },
    methods: {
        selectCarId(car_id, node_index, index){
            console.log('selectCarId', car_id, node_index, index);
            if(
                typeof this.getCarData !== 'object' || Object.keys(this.getCarData).length <= 0 
            ){
                return false;
            }
            console.log('selectCarIdS', car_id, node_index, index);
            const selCar = this.getCarData.find(car => car.key == car_id);
            const rsv_node = [...this.reserve_node];
            const members = [...rsv_node[node_index].members];
            const member = {...members[index]};
            const ledger = [...member.ledger];
            console.log('selectCarId selCar, rsv_node, member, ledger', selCar, rsv_node, member, ledger);
            if(
                ledger
                && Object.keys(ledger).length > 0
            ){
                // タイプ(select)8
                // 車種9
                // 車両情報10
                // 
                ledger.map(led =>{
                    if(parseInt(led.type_id) == 8){
                        led.value = selCar.car_type;
                    }
                    else if(parseInt(led.type_id) == 9){
                        led.value = (selCar.automaker)? selCar.automaker: '';
                        led.value += (selCar.model_number)? ' ': '';
                        led.value += (selCar.model_number)? selCar.model_number: '';
                        led.value += (selCar.model_year)? ' ': '';
                        led.value += (selCar.model_year)? selCar.model_year: '';
                    }
                    else if(parseInt(led.type_id) == 10){
                        if(
                            selCar.strage == '自走持込車'
                        ){
                            led.value = '18';
                        }
                        else if(
                            selCar.strage == 'オーナーズガレージ保管車'
                        ){
                            led.value = '19';
                        }
                    }
                });
            }
            console.log('selectCarId ledger', ledger);
            member.ledger = ledger;
            members[index] = member;
            rsv_node[node_index].members = members;
            this.reserve_node = rsv_node;
            console.log('selectCarId reserve_node', this.reserve_node);
            this.$forceUpdate();

        },
        sprmFrmDetailToggle(){
            if(this.sprmFrmDetailSw){
                this.sprmFrmDetailSw = false;
            }
            else{
                this.sprmFrmDetailSw = true;
            }
        },
        tapNodeP(node_id, tap_flg){
            if(tap_flg){
                this.tapNode(node_id);
            }
        },
        tapNode(node_id){
            console.log('tapNode', node_id);
            // let tmps = [];
            if(!this.selected_node_ids.includes(node_id)){
                const tmps = [];
                tmps.push(node_id);
                // tmps.push()
                // tmps = [...[node_id], [...this.selected_node_ids]];
                this.selected_node_ids = [...tmps, ...this.selected_node_ids];
                console.log('tapNode tmps a', tmps);
            }
            else{
                const tmps = [];
                if(Object.keys(this.selected_node_ids).length > 0){
                    Object.values(this.selected_node_ids).forEach(selected_node_id => {
                        if (selected_node_id !== node_id){
                            tmps.push(selected_node_id);
                        }
                    })
                }
                // tmps = this.selected_node_ids.filter(selected_node_id => {
                //     return (selected_node_id !== node_id);
                // })
                this.selected_node_ids = tmps;
                console.log('tapNode tmps b', tmps);
            }
            console.log('tapNode selected_node_ids instanceof', this.selected_node_ids instanceof Array);
            console.log('tapNode selected_node_ids ', this.selected_node_ids);
        },
        changeDriverType(index, node_index){
            // console.log('changeDriverType target', member.target);
            // console.log('changeDriverType member 1', member);
            const rsv_node = [...this.reserve_node];
            const member = {...rsv_node[node_index].members[index]};
            const ledger = [...member.ledger];
            if(
                ledger
                && Object.keys(ledger).length > 0
            ){
                // Object.values(member.ledger).forEach(ledger => {
                //     ledger.value = '';
                // });
                ledger.map(led =>{
                    led.value = '';
                });
            }
            member.ledger = ledger;
            if(member.target == 1){
                member.use_m_id = this.$store.state.auth.userId;
            }else{
                member.use_m_id = 0;
            }
            member.price = this.getDriverPrice(rsv_node[node_index].id, member);
            console.log('changeDriverType member 2', member);
            rsv_node[node_index].members[index] = member;
            this.reserve_node = rsv_node;
            this.$forceUpdate();
        },
        // 予約
        change_reserve_num(node_id){
            const target_rsv_node = this.nodeExtractCp(node_id);
                        console.log('change_reserve_num node_id', node_id);
                        console.log('change_reserve_num target_rsv_node', target_rsv_node);
            // const target_rsv_node = {...this.reserve_node[node_index]};
            const members = target_rsv_node.members;
            const reserve_num = target_rsv_node.reserve_num;
                        console.log('change_reserve_num members', members);
                        console.log('change_reserve_num reserve_num', reserve_num);
            if(
                typeof members === 'object' && Object.keys(members).length > 0
                && parseInt(reserve_num) > 0
            ){
                        console.log('change_reserve_num typeof members', typeof members);
                        console.log('change_reserve_num Object.keys(members).length', Object.keys(members).length);
                // membersの方が希望走行者数より多い=>消す
                if(
                    Object.keys(members).length > parseInt(reserve_num)
                ){
                    // const cnt = Object.keys(members).length - parseInt(reserve_num);
                    for(let i = Object.keys(members).length;i>=parseInt(reserve_num);i--){
                        console.log('change_reserve_num delMember', i);
                        this.delMember(node_id, i);
                    }
                }
                else if(
                    Object.keys(members).length < parseInt(reserve_num)
                ){
                    for(let i = Object.keys(members).length;i<parseInt(reserve_num);i++){
                        console.log('change_reserve_num addMember', i);
                        this.addMember(node_id);
                    }
                }
                const node_tmp = this.nodeExtractCp(node_id);
                const reserve_num_u = Object.keys(node_tmp.members).length;
                target_rsv_node.reserve_num = reserve_num_u;
                const node_index = this.reserve_node.findIndex(rsv_node => rsv_node.id == node_id);
                console.log('change_reserve_num reserve_num_u', reserve_num_u);
                this.reserve_node[node_index] = target_rsv_node;
            }

        },
        delMemberNum(node_id, target){
            this.delMember(node_id, target);
            const target_rsv_node = this.nodeExtractCp(node_id);
            const reserve_num_u = Object.keys(target_rsv_node.members).length;
            const node_index = this.reserve_node.findIndex(rsv_node => rsv_node.id == node_id);
            target_rsv_node.reserve_num = reserve_num_u;
            this.reserve_node[node_index] = target_rsv_node;
            this.$forceUpdate();
        },
        delMember(node_id, target){
            const target_rsv_node = this.nodeExtractCp(node_id);
            // const target_rsv_node = {...this.reserve_node[node_index]};
            const members = [...target_rsv_node.members];
            // console.log('delMember', node.members,node.members instanceof Array, target);
            // const members = [...node.members];
            console.log('delMember members', members, members instanceof Array);
            console.log('delMember members chk', Object.keys(members).length, typeof members, members instanceof Array);
            if(typeof members === 'object' && Object.keys(members).length > 0 && Object.keys(members).length > parseInt(target)){
                members.splice(parseInt(target), 1);
                target_rsv_node.members = members;
            }
            // target_rsv_node.reserve_num = parseInt(target_rsv_node.reserve_num) - 1;
            // console.log('delMember node.members', target_rsv_node.members);
            const node_index = this.reserve_node.findIndex(rsv_node => rsv_node.id == node_id);
            this.reserve_node[node_index] = target_rsv_node;
        },
        addMemberNum(node_id){
            // node.reserve_num = parseInt(node.reserve_num) + 1;
            // this.change_reserve_num(node_id);
            this.addMember(node_id);
            const target_rsv_node = this.nodeExtractCp(node_id);
            const reserve_num_u = Object.keys(target_rsv_node.members).length;
            const node_index = this.reserve_node.findIndex(rsv_node => rsv_node.id == node_id);
            target_rsv_node.reserve_num = reserve_num_u;
            this.reserve_node[node_index] = target_rsv_node;
            this.$forceUpdate();
        },
        addMember(node_id){
            // const node_id = node.id;
            const target_rsv_node = this.nodeExtractCp(node_id);
            // const target_rsv_node = {...this.reserve_node[node_index]};
            const members = [...target_rsv_node.members];
            // const node_id = target_rsv_node.id;

            const form = {...this.memberFrm};
            form.node_id = node_id;

            const ltmps = [];
            if(this.ledger_type_list(target_rsv_node.category_id)){
                Object.values(this.ledger_type_list(target_rsv_node.category_id)).forEach(ledger => {
                    const ltmp = {
                        id: 0,
                        stat: 1,
                        reservation_node_id: 0,
                        node_id: 0,
                        type_id: ledger.id,
                        value: ''
                    }
                    ltmps.push({...ltmp});
                });
            }

            form.ledger = [...ltmps];

            if(form && form.ledger && Object.keys(form.ledger).length > 0){
                Object.keys(form.ledger).forEach(key => {
                    form.ledger[key].node_id = node_id;
                });
            }
            // const targetNode = this.reserve_node.find(rnode => {
            //     return (rnode.id == node_id);
            // });
            // console.log('addMember', targetNode, node);
            // targetNode.members.push({...form});
            members.push({...form});
            target_rsv_node.members = members;
            const node_index = this.reserve_node.findIndex(rsv_node => rsv_node.id == node_id);
            this.reserve_node[node_index] = target_rsv_node;
            // this.reserve_node = target_rsv_node;
            // node.members.push({...form});
        },
        addFriend(member, friend){
            // add_friend_listに重複してないか検査
            const chk = this.add_friend_list.find(data => {
                return (friend.id == data.id)
            });
            if(!chk){
                this.add_friend_list.push({
                    friend_id: friend.id,
                    friend_label: friend.true_name_label,
                    kbn_id: (friend.kbn.id)? friend.kbn.id: 0,
                    label: friend.true_name_label,
                    key: friend.id,
                });
                // const tmp = {...member}
                // tmp.use_m_id = friend.id;
                member.use_m_id = friend.id;
                // member = tmp;
                this.$forceUpdate();
            }
            else{
                alert('すでに登録済です');
            }
        },
        friendSearch(member){
            if(member.tmp_search_words.length <= 0){
                alert('検索ワードを入力して下さい');
                return;
            }

            const params = {};
            // params['stat'] = [1];
            params['search_words'] = member.tmp_search_words;
            const params_ = Common.createParams(params);
            axios.post(
                config.BASE_API_URL + '/member/lists',
                params_,
                {
                headers: this.axiosHeader
                }
            )
            .then(
                (response) => {
                    member.tmp_search_list = response.data.body;
                    console.log('then friendSearch', response);
                // if(this.dashboard.drive_node) this.drive_node = this.dashboard.drive_node;
                }
            )
            .catch((err) => {
                console.log(err);
                // this.search_sales = [];
            })
            .finally(() => {
                console.log('finally friendSearch');
                this.$forceUpdate();
            });


        },

        // 検索
        searchNode(){
            this.selected_node_ids = [];
            this.loadDriveNode();
        },

        // load
        loadUser(){
            const params = {};
            params['id'] = this.$store.state.auth.userId;
            console.log('params', params);
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
            .catch((err) => {
            console.log(err);
            Promise.reject(err)
            })
            .then(() => {})
            .finally(() => {});
        },
        loadDriveCategory() {
            const params = {};
            params['stat'] = 1;
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'drive_node_category'})
                        .catch(err => Promise.reject(err))
                        .then(() => {})
                        .finally(() => {});
        },
        loadLedgerType(){
            const params = {};
            params['stat'] = 1;
            // params['is_user_view'] = 1;
            params['type'] = 'drive';
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'ledger_type'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                        })
                        .finally(() => {
                        })

        },
        loadDriveNode () {
            console.log('loadDriveNode');
            const params = {};
            params['stat'] = [1];
            // params['category_id'] = this.sel_paddock;
            params['range_start_date'] = this.sprm.date;
            params['range_end_date'] = this.sprm.date;
            // const now_date = moment().format('YYYY-MM-DD HH:mm:ss');
            // params['release_start_date'] = now_date;
            // params['release_end_date'] = now_date;
            // params['accept_start_date'] = now_date;
            // params['accept_end_date'] = now_date;
            // category
            if(this.sprm.category_id) params['category_id'] = this.sprm.category_id;
            // guest走行
            if(this.sprm.is_guest){
                params['guest_accept_flg'] = 1;
            }

            console.log('loadDriveNode params', params);
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'drive_node'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('loard complete drive_node');
                            console.log('this', this.$store.state.apidata.drive_node);
                        })
                        .finally(() => {
                            console.log('finally', this.$store.state.apidata.drive_node);
                        })
        },

        guest_input_form_sw_action(){
            if(this.guest_input_form_sw){
                this.guest_input_form_sw = false;
            }else{
                this.guest_input_form_sw = true;
            }
        },
        confirm(){
            let check = true;
            const msg = [];
            if(typeof this.reserve_node === 'object' && this.reserve_node.length > 0){
                this.reserve_node.forEach(node => {
                    console.log('confirm node', node);
                    if(parseInt(node.reserve_num) <= 0){
                        check = false;
                        msg.push('走行人数を入力してください。');
                    }
                    console.log('confirm node.members', node.members);
                    if(node.members && typeof node.members === 'object'){
                        node.members.forEach(member => {
                            if(member.target == '' || parseInt(member.target) <= 0){
                                check = false;
                                msg.push(this.word_chg('走行者を選択してください。'));
                            }
                            if(
                                typeof this.ledger_type_list(node.category_id) == 'object'
                                && this.ledger_type_list(node.category_id).length > 0    
                            ){
                                Object.values(this.ledger_type_list(node.category_id)).forEach(ledger_type_data => {
                                    const ledger_id = (typeof ledger_type_data === 'object' && ledger_type_data.id)? ledger_type_data.id: false;
                                    console.log('confirm chk ledger_id', ledger_id, member.ledger);
                                    const member_ledger = (typeof member.ledger === 'object')?
                                        member.ledger.find(ld => {return ld.type_id == ledger_id}): false;

                                    if(ledger_type_data.is_user_view == '1' && ledger_type_data.is_user_require == '1'){
                                        if(member_ledger != false && member_ledger.value == ''){
                                            console.log('confirm chk ledger_type ', ledger_type_data);
                                            console.log('confirm chk ledger ', member_ledger);
                                            let lmsg = '';
                                            if(ledger_type_data && ledger_type_data.label){
                                                lmsg += this.word_chg(ledger_type_data.label);
                                            }
                                            console.log('confirm chk guest alert 0', ledger_id, member.target, ledger_type_data, lmsg);

                                            // if(parseInt(ledger_type_data.id) == 1 && parseInt(member.target) == 200){
                                            if(parseInt(ledger_type_data.id) == 1 ){
                                                console.log('confirm chk guest alert', ledger_id, member.target, lmsg);
                                                // check = true;
                                            }else{
                                                console.log('confirm chk parseInt(ledger_type_data.id)', parseInt(ledger_type_data.id));
                                                check = false;
                                                msg.push(lmsg + this.word_chg('は必須項目です。'));
                                            }
                                        }
                                    }
                                });
                            }
                            // if(typeof this.ledger_type_list == 'object'){
                            //     Object.keys(this.ledger_type_list).forEach(ledger_id => {
                            //         if(this.ledger_type_list[ledger_id].is_user_view == '1' && this.ledger_type_list[ledger_id].is_user_require == '1'){
                            //             if(member.ledger[ledger_id].value == ''){
                            //                 console.log('confirm ledger_type ', this.ledger_type_list[ledger_id]);
                            //                 console.log('confirm ledger ', member.ledger[ledger_id]);
                            //                 let lmsg = '';
                            //                 if(this.ledger_type_list[ledger_id] && this.ledger_type_list[ledger_id].label){
                            //                     lmsg += this.word_chg(this.ledger_type_list[ledger_id].label);
                            //                 }
                            //                 console.log('guest alert 0', ledger_id, member.target, this.ledger_type_list[ledger_id], lmsg);

                            //                 // if(parseInt(this.ledger_type[ledger_id].id) == 1 && parseInt(member.target) == 200){
                            //                 if(parseInt(this.ledger_type_list[ledger_id].id) == 1 ){
                            //                     console.log('guest alert', ledger_id, member.target, lmsg);
                            //                     // check = true;
                            //                 }else{
                            //                     check = false;
                            //                     msg.push(lmsg + this.word_chg('は必須項目です。'));
                            //                 }
                            //             }
                            //         }
                            //     });
                            // }
                        });
                    }
                });
            }else{
                check = false;
                msg.push(this.word_chg('走行予約枠が設定されていません。'));
            }
            if(!check){
                // let message = '';
                if(msg.length > 0){
                    // msg.forEach(m => {
                    //     message += this.word_chg(m) + ',';
                    // })
                    alert(msg.join('\n'));
                }
                // alert(message);
            }else{
                window.scrollTo(0, 0);
                this.reserve_step = 100;
            }
        },
        next(){
            // 予約申し込み用オブジェクト
            this.reserve_node = [];
            this.selected_node_ids.forEach(node_id => {
                const node = this.nodeExtract(node_id);
                console.log('next node', node_id, node);
                node['reserve_num'] = (typeof this.sprm === 'object' && (typeof this.sprm.reserve_num === 'string' || typeof this.sprm.reserve_num === 'number'))? parseInt(this.sprm.reserve_num): 1;
                this.reserve_node.push(node);
                if(
                    node.members && Object.keys(node.members).length < parseInt(node['reserve_num'])
                ){
                    const cnt = parseInt(this.sprm.reserve_num) - Object.keys(node.members).length;
                    for(let i=0;i<cnt;i++){
                        this.addMember(node.id);
                    }
                }
                else if(
                    node.members && Object.keys(node.members).length > parseInt(node['reserve_num'])
                ){
                    // const cnt = Object.keys(node.members).length - parseInt(this.sprm.reserve_num);
                    for(let i=Object.keys(node.members).length;i>parseInt(node['reserve_num']);i--){
                        this.delMember(node.id,i);
                    }
                }
            });
            console.log('next reserve_node', this.reserve_node);
            window.scrollTo(0, 0);
            this.reserve_step = 10;
        },
        prev(step){
            this.reserve_step = step;
        },
        reservation(){
            console.log('reservation reserve_node', this.reserve_node);
            this.form_res = false;
            const params = {};
            params['m_id'] = this.$store.state.auth.userId;
            params['node_type'] = 'drive';
            if(Object.keys(this.reserve_node).length > 0){
                // params['node'] = this.reserve_node;
                const reservation = [];
                Object.values(this.reserve_node).forEach(node => {
                    if(node.members && Object.keys(node.members).length > 0){
                        Object.values(node.members).forEach(member => {
                            const ledger_data = [];
                            if(member.ledger && Object.keys(member.ledger).length > 0){
                                Object.values(member.ledger).forEach(ledger => {
                                    ledger['node_id'] = node.id;
                                        // console.log('reservation reserve_node ledger', ledger);
                                        // console.log('reservation reserve_node ledger by param', this.get_ledger_value_by_param(member, ledger.type_id));
                                    ledger_data.push( ledger);
                                });
                            }
                            const price = this.getDriverPrice(node.id, member);
                            member.price = price;
                            reservation.push({
                                reservation_id: 0,
                                node_id: node.id,
                                use_m_id: member.use_m_id,
                                kbn_id: member.kbn_id,
                                checkin_id: 0,
                                use_guest_id: member.use_guest_id,
                                is_use: 0,
                                is_guest: (parseInt(member.use_guest_id) > 0)? 1: 0,
                                is_cancel: 0,
                                price: member.price,
                                ledger: ledger_data,
                                note: {}
                            });
                        });
                    }
                });
                params['reserve'] = reservation;
            }
            console.log('reservation params', params);
            // return true;
            return this.$store.dispatch('updateBasic', {data: params, target: 'reservation'})
                .then((response) => {
                    if(typeof response === 'object'){
                        if(response.data.alert.title == 'SUCCESS'){
                            alert(this.word_chg('予約が完了しました。'));
                            // this.back()
                            this.form_res = true;
                        }else{
                            this.alertMessage = response.data.alert.message;
                            this.alertClass = response.data.alert.addClass;
                            alert(this.alertMessage);
                        }
                    }else{
                        alert(this.word_chg('予約できませんでした。'));
                    }
                })
                .catch(
                    () => {
                    err => Promise.reject(err);
                        alert(this.word_chg('予約できませんでした。'));
                    }
                )
                .finally(() => {
                    // this.loadDriveNode();
                    // this.$refs.closeRsvModal.click();
                    this.$forceUpdate();
                    // this.$refs.closeNodeModalParent.click();
                    if(this.form_res){
                        this.$router.push({ path: '/' })
                    }
                });
        }
    },
    computed: {
        ...mapState({
            drive_node_category: state => state.apidata.drive_node_category,
            kbn_list: state => state.apidata.member_kbn,
            drive_node: state => state.apidata.drive_node,
            ledger_type: state => state.apidata.ledger_type,
            user: state => state.apidata.user,
            // paddock_list: state => state.apidata.drive_node_category,
        }),
        get_ledger_value_by_param: function(){
            const get_func = this.get_ledger_by_param;
            return function(member, param){
                return (typeof get_func(member,param) === 'object')? get_func(member,param).value: '';
            }
        },
        get_ledger_by_param: function(){
            return function(member, param){
                if(
                    typeof member === 'object' 
                    && typeof member.ledger === 'object'
                    && member.ledger.find(led => {return (led.type_id == param || led.relation_column == param)})
                ){
                    return member.ledger.find(led => {return (led.type_id == param || led.relation_column == param)});
                }
                return false;
            }
        },

        ledger_type_list: function(){
            const target_type = this.ledger_type;
            return function(category_id){
                const filters = target_type.filter((type) => {
                    if(
                        typeof type === 'object' && typeof type.category_relation === 'object'
                        && type.category_relation.indexOf(category_id) >= 0
                    ){
                        return type;
                    }
                });
                return filters.sort((a, b) => {
                if(parseInt(a.sort) < parseInt(b.sort)){
                    return -1;
                }else{
                    return 1;
                }
            })
            }
        },

        // ledger_type_list: function(){
        //     const target_type = [...this.ledger_type];
        //     return target_type.sort((a, b) => {
        //         if(parseInt(a.sort) < parseInt(b.sort)){
        //             return -1;
        //         }else{
        //             return 1;
        //         }
        //     });
        // },
        car_type_param: function(){
            return function (car_type){
                const tmps = [];
                if(typeof car_type === 'object'){
                    Object.values(car_type).forEach(param => {
                        tmps.push({
                            key: param.id,
                            label: this.word_chg(param.label)
                        });
                    })
                }
                return tmps;
            }
        },
        node_information_message: function(){
            const tmps = [];
            if(
                typeof this.reserve_node === 'object' && Object.keys(this.reserve_node).length > 0
            ){
                Object.values(this.reserve_node).forEach(node => {
                    console.log('node_information_message', node);
                    if(node.information_message){
                        tmps.push(this.word_chg(node.information_message));
                    }
                })
            }
            return tmps;
        },
        reserve_num_list_node: function(){
            // const num_list = this.reserve_num_list;
            const rsv_node = this.reserve_node;
            return function(node_id){
                const target_node = rsv_node.find(n => {
                    return n.id == node_id;
                });
                const list = [];
                if(target_node && target_node.remain_count && parseInt(target_node.remain_count) > 0){
                    for(let i=1; i<=parseInt(target_node.remain_count);i++){
                        list.push({
                            label: i + ' ' + this.word_chg('select人'),
                            key: i
                        });
                    }
                }
                return list;
            }
        },
        list_val_set: function(){
            return function(val, options){
                console.log('list_val_set options', options);
                if(typeof options === 'object'){
                    const option = options.find((data) => {
                        return data.key == val;
                    })
                    return (typeof option === 'object')? this.word_chg(option.label): '';
                }
                return val;
            }
        },
        rsvNodeListSw: function(){
            if(
                this.sprm.date != '' 
                // && this.sprm.reserve_num > 0 
                // && this.sprm.category_id > 0
            ){
                return true;
            }
            return false;
        },
        axiosHeader: function(){
            return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
        },
        // login user
        getMyData: function(){
            const mydata = this.user.find((data) => {
            return data.id == this.$store.state.auth.userId;
            })
            return mydata;
        },
        getFriendData: function(){
            console.log('getFriendData', this.getMyData);
            if(this.getMyData.friendship){
                return this.getMyData.friendship;
            }
            return [];
        },
        addFriendData:function(){
            const tmps = [];
            if(this.add_friend_list){
                Object.values(this.add_friend_list).forEach(friend => {
                    tmps.push({
                        key: friend.id,
                        label: friend.true_name_label
                    })
                })
            }
            return tmps;
        },
        getFriendDataAddList: function(){
            const tmps = [...this.getFriendData];
            const tmps2 = [...this.addFriendData];
            tmps2.push({
                key: 0,
                label: '新規追加'
            });
            return [...tmps, ...tmps2];
        },
        getGuestData: function(){
            if(this.getMyData.guest){
                return this.getMyData.guest;
            }
            return [];
        },
        getGuestDataAddList: function(){
            const tmps = [...this.getGuestData];
            // tmps.push({
            //     key: 0,
            //     label: '新規追加'
            // });
            return tmps;
        },
        getCarData: function(){
            if(this.getMyData.cars){
                return this.getMyData.cars;
            }
            return [];
        },
        getDriverPriceTotal: function(){
            let totalPrice = 0;
            if(Object.keys(this.reserve_node).length > 0){
                Object.values(this.reserve_node).forEach(node => {
                    if(node.members && Object.keys(node.members).length > 0){
                        Object.values(node.members).forEach(member => {
                            const price =this.getDriverPrice(node.id, member);
                            if(price){
                                totalPrice = totalPrice + parseInt(price);
                            }
                        });
                    }
                });
            }
            return totalPrice;
        },
        getDriverPriceNodeTotal: function(){
            const rsv_node = this.reserve_node;
            return function(node_id){
                let totalPrice = 0;
                const node = rsv_node.find((n) => {
                    return (n.id == node_id);
                });
                // console.log('getDriverPriceNodeTotal node', node);
                if(typeof node === 'object' && node.members && typeof node.members === 'object' && Object.keys(node.members).length > 0){
                    Object.values(node.members).forEach(member => {
                        const price = this.getDriverPrice(node.id, member);
                // console.log('getDriverPriceNodeTotal member', member);
                // console.log('getDriverPriceNodeTotal getDriverPrice', price);
                        if(price){
                            totalPrice = totalPrice + parseInt(price);
                        }
                    });
                }
                return totalPrice;
            }
        },
        getDriverPrice_2:function(){
            const drive_node = this.drive_node;
            const reserve_node = this.reserve_node;
            const userId = this.$store.state.auth.userId;
            const myData = this.getMyData;
            const friend_list = this.getFriendDataAddList;

            return function(index, node_index){
                console.log('getDriverPrice_2 reserve_node', reserve_node, node_index);
                const target_rsv_node = {...reserve_node[node_index]};
                const member = {...target_rsv_node.members[index]};
                const target_node = drive_node.find(node => {
                    return (node.id == target_rsv_node.id);
                });
                // console.log('getDriverPrice_2 myData', myData);
                // console.log('getDriverPrice_2 friend_list', friend_list);
                    console.log('getDriverPrice_2 target_rsv_node', target_rsv_node);
                    console.log('getDriverPrice_2 member', member);
                    console.log('getDriverPrice_2 target_node', target_node);
                let price = '';
                if(member.use_guest_id > 0){
                    price = target_node.price;
                }
                else if(
                    (member.use_m_id == userId)
                    || (member.use_m_id > 0)
                ){
                    let kbn_id = '';
                    if(member.use_m_id == userId){
                        kbn_id = myData.kbn.id;
                    }else{
                        const tmp = friend_list.find(d => {
                            return (d.friend_id == member.use_m_id)
                        });
                        kbn_id = tmp.kbn_id;
                    }
                // console.log('getDriverPrice kbn_id', kbn_id);
                console.log('getDriverPrice kbn_id', target_node.kbns_price_list);
                    if(target_node.kbns_price_list){
                        const pl = target_node.kbns_price_list.find(kbn => {
                            return (kbn.id == kbn_id)
                        });
                        if(pl){
                            price = pl.price;
                        }
                    }
                }
                console.log('getDriverPrice price', price);
                // member.price = price;
                return price;
            }
        },
        getDriverPrice:function(){
            const drive_node = this.drive_node;
            const userId = this.$store.state.auth.userId;
            const myData = this.getMyData;
            const friend_list = this.getFriendDataAddList;

            return function(node_id, member){
                // console.log('getDriverPrice member', member.use_m_id, userId);
                const target_node = drive_node.find(node => {
                    return (node.id == node_id);
                });
                console.log('getDriverPrice myData', myData);
                // console.log('getDriverPrice friend_list', friend_list);
                //     console.log('getDriverPrice target_node', target_node);
                let price = '';
                if(member.use_guest_id > 0){
                    price = target_node.price;
                }
                else if(
                    (member.use_m_id == userId)
                    || (member.use_m_id > 0)
                ){
                    let kbn_id = '';
                    if(member.use_m_id == userId){
                        kbn_id = myData.kbn.kbn_id;
                    }else{
                        const tmp = friend_list.find(d => {
                            return (d.friend_id == member.use_m_id)
                        });
                        kbn_id = tmp.kbn_id;
                    }
                console.log('getDriverPrice kbn_id', kbn_id);
                console.log('getDriverPrice kbn_id', target_node.kbns_price_list);
                    if(target_node.kbns_price_list){
                        const pl = target_node.kbns_price_list.find(kbn => {
                            return (kbn.id == kbn_id)
                        });
                        if(pl){
                            price = pl.price;
                        }
                    }
                }
                console.log('getDriverPrice price', price);
                // member.price = price;
                return price;
            }
        },
        getNodeSubLabel: function(){
            return function(item){
                if(
                    typeof item === 'object' 
                    && item.sub_label != false
                    && item.sub_label != 'false'
                    && item.sub_label != null 
                    && item.sub_label != 'null'
                ){
                    return item.sub_label;
                }
                return false;
            }
        },
        getNodePrice_to_member: function(){
            const drive_node = this.drive_node;
            // const userId = this.$store.state.auth.userId;
            const myData = this.getMyData;
            return function(node_id){
                // console.log('getDriverPrice member', member.use_m_id, userId);
                const target_node = drive_node.find(node => {
                    return (node.id == node_id);
                });
                let price = '';
                
                let kbn_id = '';
                kbn_id = myData.kbn.kbn_id;
                if(
                    typeof target_node === 'object'
                    && typeof target_node.kbns_price_list === 'object'
                    && Object.keys(target_node.kbns_price_list).length > 0
                ){
                    const pl = target_node.kbns_price_list.find(kbn => {
                        return (kbn.id == kbn_id)
                    });
                    if(pl){
                        price = pl.price;
                    }
                }
                else if(target_node.guest_accept_flg === 'true'){
                    price = target_node.price;
                }
                if(parseInt(price) > 0){
                    return 0;
                    // return this.number_format(parseInt(price));
                }
                return 0;
            }

        },
        driverTypeList: function(){
            return function(node){

                console.log('driverTypeList node', node);
                const list = [];
                if(node.is_myself_reservation == undefined || node.is_myself_reservation == 'false' || node.is_myself_reservation == false){
                    list.push({
                        key: 1,
                        label: this.word_chg('本人')
                    });
                }
                // list.push({
                //     key: 100,
                //     label: this.word_chg('フレンド')
                // });
                // guest可能か
                if(node.guest_accept_flg != 'false'){
                    list.push({
                    key: 200,
                    label: this.word_chg('ゲスト')
                    });
                }
                console.log('driverTypeList list', list);
                return list;
            }
        },
        driverTypeList_: function(){
            return function(is_guest){
                console.log('driverTypeList is_guest', is_guest);
                const list = [];
                list.push({
                    key: 1,
                    label: this.word_chg('本人')
                });
                // list.push({
                //     key: 100,
                //     label: this.word_chg('フレンド')
                // });
                // guest可能か
                if(is_guest != 'false'){
                    list.push({
                    key: 200,
                    label: this.word_chg('ゲスト')
                    });
                }
                console.log('driverTypeList list', list);
                return list;
            }
        },
        memberFrm: function(){
            const form = {
                        id: 0,
                        stat: 0,
                        node_id: 0,
                        use_m_id: 0,
                        kbn_id: 0,
                        reservation_id: 0,
                        checkin_id: 0,
                        use_guest_id: 0,
                        is_use: 0,
                        is_cancel: 0,
                        price: 0,
                        is_guest: 0,
                        ledger: [],
                        note: {},
                        target: 0,
                        tmp_label: '',
                        tmp_tel: '',
                        tmp_search_words: '',
                        tmp_search_list:[],
            }
            return form;
        },
        member_type_list: function(){
            const list ={
                0: {
                    label: '会員',
                    value: 0,
                    key: 0
                },
                1: {
                    label: 'ゲスト',
                    value: 1,
                    key: 1
                },
            }
            return list;
        },
        node_available_reservation: function(){
            return function (item){
                return item;
            }
        },
        category_label: function(){
            const cate = this.drive_node_category;
            return function(category_id){
                console.log('category_label', category_id, cate);
                if(Object.keys(cate).length > 0 && cate.find((val) =>{return val.id == category_id})){
                    const tmp = cate.find((val) =>{return val.id == category_id});
                    return tmp.label;
                }else{
                    return (category_id)? category_id: '';
                }
            }
        },
        node_style: function(){
            const baseStyle = 'cursor: pointer;';
            const select_ids = this.selected_node_ids;
            return function(item){
                let style_ = 'background:';

                if(item.bg_color){
                    style_ += item.bg_color + ';';
                }
                else{
                    style_ += '#FFFFFF;';
                }
                style_ += 'color:';
                if(item.text_color){
                    style_ += item.text_color + ';';
                }
                else{
                    style_ += '#000000;';
                }
                if(item.id == 16){
                    // console.log('node_style selected_node_ids ', this.selected_node_ids);
                    // console.log('node_style typeof ', typeof this.selected_node_ids);
                    // console.log('node_style selected_node_ids instanceof', this.selected_node_ids instanceof Array);
                    // console.log('node_style include ', this.selected_node_ids.includes(item.node_id));
                }
                if(
                    select_ids && typeof select_ids === 'object' &&
                    select_ids.includes(item.node_id)
                ){
                    style_ += 'border: solid 2px #FF0000;margin:-2px;';
                }
                const baseRem = 5.62640660165;
                // const baseRem = 5.62640660165 / 2;
                // const baseRem = 5.62640660165 * 2;
                if(parseInt(item.time_diff) >= 10){
                    const diff_c = (parseInt(item.time_diff) / 10);

                    style_ += 'height: calc(' + String((baseRem * diff_c)) + 'rem - 6px) !important;';
                }
                return baseStyle + style_ + '';

            }
        },
        li_timesc_style: function(){
            const baseRem = 5.62640660165;
            return 'height: calc(' + String((baseRem / 2)) + 'rem) !important;';
        },
        node_p_style: function(){
            return function(item){
                if(item.time_diff > 10){
                    return '';
                }else{
                    return 'd-flex align-items-center justify-content-center';
                }
            }
        },
        node_class: function(){
            const baseClass = 'reserveTimeSchedule__label d-flex align-items-center justify-content-center  reserveTimeSchedule__label--';
            return function(item){
                // let diff = '';
                // if(parseInt(item.time_diff) > 10){
                //     diff = '40';
                // }
                // else{
                //     diff = 10;
                // }
                return baseClass + item.time_diff + 'min';
            }
        },
        get_drive_node_item: function(){
            const drive_node = this.drive_node;
            const target_date = this.sprm.date;
            // const target_day = this.sprm.day;
            return function (time, cols){
                const nodes = (typeof drive_node ==='object')? drive_node.filter(node => {
                    return (node.range_start_date == target_date);
                }): [];
                const tmps = [];
                // console.log('get_drive_node_item', time, cols);
                Object.values(nodes).forEach(node => {
                    if(node.items && Object.keys(node.items).length > 0){
                        const items = node.items.filter(item => {
                            if(item.node_id == '6172' && time == '09:00' && item.start_date_time == time && cols.includes(parseInt(item.col_num))) console.log('AAAAAAAA1', item);
                // console.log('get_drive_node_item', time, cols, cols.includes(parseInt(item.col_num)));
                            return (item.start_date_time == time && cols.includes(parseInt(item.col_num)));
                            
                            // const regex = /[^0-9]/g;
                            // const item_rep = item.start_date_time.replace(regex, "");
                            // const item_time_number = parseInt(item_rep);
                            // const time_rep = time.replace(regex, "");
                            // const time_number = parseInt(time_rep);
                            // return ((item.start_date_time == time || (item_time_number - 5) == parseInt(time_number)) && cols.includes(parseInt(item.col_num)));
                        });
                        if(time == '09:00' && node.id == '6172'){
                            console.log('AAAAAAAA2', items);
                        }
                        if(Object.keys(items).length > 0){
                            Object.values(items).forEach(item => {
                                const item_tmp = {...item};
                                item_tmp.remain_count = node.remain_count;
                                item_tmp.reserve_limit = node.reserve_limit;
                                tmps.push(item_tmp);
                            });
                        }
                    }
                });
                return tmps;
            }
        },
        drive_node_items: function(){
            const tmps = {};
            if(this.sprm.date){
                for(let i = 1;i<=moment(this.sprm.date).endOf('month').format('D');i++){
                    tmps[i] = {};
                }
                        // console.log('drive_node_items length > obj', this.drive_node);
                Object.keys(this.drive_node).forEach((index) => {
                        console.log('drive_node_items length > obj', this.drive_node[index]);
                    if(Object.keys(this.drive_node[index].items).length > 0){
                        console.log('drive_node_items length > obj', this.drive_node[index].items);
                        Object.keys(this.drive_node[index].items).forEach(idx => {
                            if(
                                !tmps[this.drive_node[index].items[idx].start_date_day_num][this.drive_node[index].items[idx].start_date_sort_num]
                            ){
                                tmps[this.drive_node[index].items[idx].start_date_day_num][this.drive_node[index].items[idx].start_date_sort_num] = [];
                            }
                            tmps[this.drive_node[index].items[idx].start_date_day_num][this.drive_node[index].items[idx].start_date_sort_num].push(
                                this.drive_node[index].items[idx]
                            );
                        });
                    }
                });
            }
            return tmps;
        },
        nodeItem:function(){
            const node_items = this.drive_node_items;
            return function(day){
                const tmps = {};
                // console.log('getNode', node_id, this.target_day, target_date.format("YYYY-MM-DD"));
                if(day > 0 && node_items[day] && Object.keys(node_items[day]).length > 0){
                    const keys = Object.keys(node_items[day]);
                    keys.sort();
                    keys.forEach(key => {
                        tmps[key] = node_items[day][key];
                    });
                }
                return tmps;
            }
        },
        nodeExtract:function(){
            const nodes = this.drive_node;
            return function(node_id){
                return nodes.find(node => {
                    return node.id == node_id;
                });
            }
        },
        nodeExtractCp:function(){
            const nodes = [...this.drive_node];
            return function(node_id){
                return nodes.find(node => {
                    return node.id == node_id;
                });
            }
        },


        end_hour: function(){
            return 19
        },
        timesc_unit: function(){
            const unit_min = 5;
            const unit_p = Math.floor(60/unit_min);
            const start_hour = 6;
            const end_hour = this.end_hour;
            const units = [];
            for(let i=start_hour;i<end_hour;i++){
                for (let e = 0; e < unit_p; e++) {
                    const hourZ = (i<10)? '0' + i: i;
                    const minP = (e * unit_min);
                    const minZ = (minP<10)? '0' + minP: minP;
                    units.push(
                        {
                            label: hourZ + ':' + minZ,
                            hour: i,
                            min: minP
                        }
                    )
                }
            }
            return units;
        },
        reserve_num_list: function(){
            const list = [];
            for(let i=1; i<=6;i++){
                list.push({
                    label: i + ' ' + this.word_chg('select人'),
                    key: i
                });
            }
            return list;
        },
    },
    created () {
        if(this.$route.query.param_detail_flg) this.sprmFrmDetailSw = true;

        if(this.$route.query.param_reserve_num) this.sprm.reserve_num = this.$route.query.param_reserve_num;
        if(this.$route.query.param_date){
            this.sprm.date = this.$route.query.param_date;
        }
        if(this.$route.query.param_category_id) this.sprm.category_id = this.$route.query.param_category_id;
        if(this.sprm.date){
            this.sprm.day = moment(this.sprm.date).format("D");
        }
        this.loadDriveCategory();
        this.loadDriveNode();
        this.loadUser();
        this.loadLedgerType();
      // this.sel_month = this.month_list[12].key;
    },
}
</script>
